import { ISuperTableComponent } from '@modeso/types__aumico-lib-annualreport-be';

export interface ISuperTableDelegate {
    superTableComponentData?(superTableData: ISuperTableComponent, componentIndex: number);
}
